/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-add-dark': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<rect pid="0" x=".25" y=".75" width="19.5" height="19.5" rx="1.75" _fill="#393945" _stroke="#484858" stroke-width=".5"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M10.5 5.5a.5.5 0 0 0-1 0V10H5a.5.5 0 0 0 0 1h4.5v4.5a.5.5 0 0 0 1 0V11H15a.5.5 0 0 0 0-1h-4.5V5.5z" _fill="#D5DAF4"/>'
  }
})
